import { ChangedBudgetItem } from '@/components/ChangedBudgetItem';
import { PercentItem } from '@/components/PercentItem';
import { cn } from '@/utils';
import { Tooltip, Typography } from '@analytical-alley/ui';
import React, { ReactNode } from 'react';

interface Props {
    title: string;
    value: number | string;
    formatNumber?: (val: number) => string;
    percentage?: number | undefined;
    absChangeValue?: number;
    className?: string;
    description?: string | ReactNode;
    titleTooltip?: string;
}

export const CurrencyBlock = ({
    percentage,
    value,
    absChangeValue,
    title,
    className,
    formatNumber,
    description,
    titleTooltip,
}: Props) => {
    return (
        <div
            className={cn(
                'self-stretch h-[8rem] flex flex-col items-center justify-around rounded-lg dark:bg-[#FBFEFF21] px-6 py-4',
                className,
            )}
        >
            <Typography
                variant="titleS"
                responsive={false}
                className="text-[1.437rem] text-nowrap"
                tooltip={titleTooltip}
            >
                {title}
            </Typography>
            <Typography
                variant="titleM"
                responsive={false}
                className="text-[2rem] font-mono"
            >
                {description ? '' : value}
                {description && (
                    <span className="pl-2">
                        <Tooltip>
                            <Tooltip.Trigger>{value}</Tooltip.Trigger>
                            <Tooltip.Content className="tooltip-content">
                                {description}
                            </Tooltip.Content>
                        </Tooltip>
                    </span>
                )}
            </Typography>
            {typeof percentage === 'number' && (
                <span className="flex gap-2">
                    <PercentItem percent={percentage} />
                    {absChangeValue && (
                        <div className="flex gap-2 text-xs">
                            <span>/</span>
                            <span className="text-xs">
                                <ChangedBudgetItem
                                    showArrows
                                    value={absChangeValue}
                                    formatNumber={formatNumber}
                                />
                            </span>
                        </div>
                    )}
                </span>
            )}
        </div>
    );
};
